// @mui material components
import Icon from "@mui/material/Icon";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiBadge from "components/VuiBadge";

// React icons
import { IoArrowUp, IoArrowDown } from "react-icons/io5";

export default function data(transactions = []) {
  // Helper function to format time ago
  const timeAgo = (timestamp) => {
    const now = Math.floor(Date.now() / 1000);
    const diff = now - timestamp;
    
    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  };

  // Helper function to format amount
  const formatAmount = (amount) => {
    const absAmount = Math.abs(amount);
    return absAmount.toFixed(4);
  };

  const rows = transactions.map((tx) => {
    const isSend = tx.category === 'send';
    const isReceive = tx.category === 'receive';
    const amount = tx.amount != null && !isNaN(tx.amount) ? Math.abs(tx.amount) : 0;
    const confirmations = tx.confirmations || 0;
    const hasValidTime = tx.time && !isNaN(tx.time) && tx.time > 0;
    const hasValidTxid = tx.txid && typeof tx.txid === 'string' && tx.txid.length > 0;
    
    return {
      txid: (
        <VuiBox display="flex" alignItems="center">
          <Icon sx={{ color: isSend ? "#FF6B6B" : "#4CAF50", fontSize: "20px", mr: "12px" }}>
            {isSend ? <IoArrowUp /> : <IoArrowDown />}
          </Icon>
          <VuiBox>
            <VuiTypography color="white" variant="button" fontWeight="medium">
              {hasValidTxid ? tx.txid.substring(0, 12) + '...' : 'N/A'}
            </VuiTypography>
            <VuiTypography variant="caption" color="text">
              {tx.address && typeof tx.address === 'string' ? tx.address.substring(0, 20) + '...' : '-'}
            </VuiTypography>
          </VuiBox>
        </VuiBox>
      ),
      type: (
        <VuiBox display="flex" alignItems="center">
          <VuiBadge
            badgeContent={isSend ? "Send" : isReceive ? "Receive" : tx.category || "Unknown"}
            color={isSend ? "error" : "success"}
            variant="contained"
            size="xs"
            container
          />
        </VuiBox>
      ),
      amount: (
        <VuiTypography 
          variant="button" 
          color={isSend ? "error" : "success"} 
          fontWeight="bold"
        >
          {isSend ? '-' : '+'}{formatAmount(amount)} MYT
        </VuiTypography>
      ),
      time: (
        <VuiTypography variant="button" color="text" fontWeight="regular">
          {hasValidTime ? timeAgo(tx.time) : 'Unknown'}
        </VuiTypography>
      ),
      status: (
        <VuiBox display="flex" alignItems="center">
          <VuiBadge
            badgeContent={confirmations >= 6 ? "Confirmed" : confirmations > 0 ? `${confirmations} conf` : "Pending"}
            color={confirmations >= 6 ? "success" : confirmations > 0 ? "warning" : "info"}
            variant="contained"
            size="xs"
            container
          />
        </VuiBox>
      ),
    };
  });

  return {
    columns: [
      { name: "txid", align: "left" },
      { name: "type", align: "left" },
      { name: "amount", align: "center" },
      { name: "time", align: "center" },
      { name: "status", align: "center" },
    ],
    rows: rows.length > 0 ? rows : [
      {
        txid: (
          <VuiBox display="flex" alignItems="center" justifyContent="center">
            <VuiTypography variant="button" color="text" fontWeight="regular">
              No transactions yet
            </VuiTypography>
          </VuiBox>
        ),
        type: <VuiBox />,
        amount: <VuiBox />,
        time: <VuiBox />,
        status: <VuiBox />,
      }
    ],
  };
}
